import { RowContent } from '@shared/components/RowContent';
import { ButtonView } from '@shared/components/View';
import { useButtonBarContext } from './ButtonBarContext';
import { ButtonProps } from './ButtonProps';
import { useOnClickAsync } from './useOnClickAsync';
import styles from './Button.module.css';

export function Button({
  variant = 'tertiary',
  size = 'large',
  icon,
  iconSize,
  iconOnly,
  label,
  inactive,
  children,
  startContent,
  endContent,
  showDownArrow,
  danger,
  engaged,
  className,
  style,
  disabled,
  loading: loadingProp,
  onClick: onClickProp,
  ...props
}: ButtonProps) {
  const [loading, onClick] = useOnClickAsync({ onClick: onClickProp, loading: loadingProp });
  const buttonbar = useButtonBarContext();

  return (
    <ButtonView
      className={[styles.button, className]}
      style={style}
      disabled={disabled || loading || undefined}
      data-variant={buttonbar ? buttonbar.variant : variant}
      data-size={buttonbar ? buttonbar.size : size}
      data-loading={loading || undefined}
      data-danger={danger || undefined}
      data-engaged={engaged || undefined}
      data-inactive={inactive || undefined}
      data-icon-only={iconOnly || undefined}
      data-show-arrow={showDownArrow || undefined}
      onClick={onClick}
      vars={{ 'icon-size': iconSize }}
      {...props}
    >
      <RowContent
        icon={icon}
        iconSize={iconSize}
        label={label}
        startContent={startContent}
        endContent={endContent}
      >
        {children}
      </RowContent>
    </ButtonView>
  );
}
